import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ValidationService } from '../../shared/_services/validation.service';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit {

  addUser: any = FormGroup;
  userData: any;
  userId: any;
  mobnumPattern = '^((\\+91-?)|0)?[0-9]{10}$';
  error = false;
  success = false;
  errorMessage: String = '';
  successMessage: String = '';
  public modalRef: BsModalRef;
  public loading = false;
  config = {
    animated: true,
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true,
    class: 'changePwdModal'
  };

  constructor(private fb: FormBuilder, private http: AuthService, private router: Router, private route: ActivatedRoute, private modalService: BsModalService, private validation: ValidationService) { }

  getProfileData(userId) {
    this.http.getUserDataApi(userId).subscribe(res => {
      //console.log(res);
      this.initForm(res.responseObj);
      this.userData = res.responseObj;
    },
      error => {
        console.log(error);
      });
  }

  initForm(data){
    this.addUser = this.fb.group({
      userId: [data && data.userId ? data.userId : '' ],
      firstName : [data && data.firstName ? data.firstName : '', Validators.compose([Validators.minLength(1), Validators.required])],
      lastName : [data && data.lastName ? data.lastName : '', Validators.compose([Validators.minLength(1), Validators.required])],
      email : [data && data.email ? data.email : '', [Validators.required, , Validators.pattern(this.validation.email_regexPattern)]],
      phoneNumber  : [data && data.phoneNumber ? data.phoneNumber : '', [Validators.maxLength(10), Validators.pattern(this.mobnumPattern)]]
    });
  }

  updateStatus(id,status){
    //console.log(id, '***', status);
    this.http.updateStatusApi(id,status).subscribe(res=>{
      //console.log(res);
      this.getProfileData(this.userId);
    },
    error => { 
      console.log(error);
      this.getProfileData(this.userId);
    });
  }

  ngOnInit() {
    this.initForm(null);
    this.route.params.subscribe(params => {
      if (params.userId) {
        this.userId = params.userId;
  
        this.getProfileData(this.userId);
      }
    });
  }

    //validating white space in form control
    public noWhitespaceValidator(control: FormControl) {
      //console.log(control);
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { 'whitespace': true };
  }
  
  //navigating to user-management page upon clicking cancel button
  cancel() {
    this.router.navigate(['/users']);
  }

  create(user, modalData) {
    this.loading = true;
    this.http.updateUserApi(user).subscribe(
      res=>{
        this.loading = false;
        if(res.error === 0) {
          this.error = false;
          this.success = true;
          this.errorMessage = '';
          this.successMessage = res.message;
          this.modalRef = this.modalService.show(modalData, this.config);
        }else{
          this.success = false;
          this.error = true;
          this.successMessage = '';
          this.errorMessage = res.message;
          this.modalRef = this.modalService.show(modalData, this.config);
          console.log(this.errorMessage);
        }
      },
      error=>{
        this.loading = false;
        this.success = false;
        this.error = true;
        this.successMessage = '';
        this.errorMessage = error.message ? error.message : 'Failed, Please try again' ;
        this.modalRef = this.modalService.show(modalData, this.config);
      }
    )
  }

  clearExisitingErrors() {
    this.success = false;
    this.error = false;
    this.successMessage = '';
    this.errorMessage = '';
  }

  login() {
    this.modalRef.hide();
    this.router.navigate(['/users']);
  }

  ok() {
    this.modalRef.hide();
    // this.router.navigate(['/users']);
  }
}



// WEBPACK FOOTER //
// ./src/app/user-management/add-user/add-user.component.ts